import React, {useState} from "react"
import {AsyncResultIdleRequestState} from "../../types/asyncResultIdle"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import {ErrorDocument} from "../../resources/common"
import Admonition from "../Admonitions/Admonition"
import {refreshAndClose} from "../../utilities/modals"

export interface CancelApplicationModalProps<T> {
	title: string
	close: () => void
	onSuccess: () => void
	cancelFn: (token: string, reason: string) => void
	state: AsyncResultIdleRequestState<T, ErrorDocument>
	accessToken: string
	warningMessage: string
}

export function CancelApplicationModal<T>({
	title,
	close,
	onSuccess,
	cancelFn,
	state,
	accessToken,
	warningMessage,
}: CancelApplicationModalProps<T>) {
	const [requestedBy, setRequestedBy] = useState<"Customer" | "Org">("Customer")
	const [reason, setReason] = useState<string>("")
	const textReason = reason ? `By ${requestedBy} - ${reason}` : `By ${requestedBy}`

	return (
		<AsyncResultModal
			title={title}
			close={refreshAndClose(onSuccess, close)}
			buttonClassname="is-black"
			state={state}
			buttonText="Confirm"
			successText="Canceled"
			onSubmit={() => cancelFn(accessToken, textReason)}
			errorToText={(err) => err.errors[0].title}
		>
			<div className="field">
				<label className="label cancel-application-requested-by">Requested by</label>
				<div className={"radio-select"}>
					<label>
						{" "}
						<input
							readOnly
							type="radio"
							checked={requestedBy == "Customer"}
							name="requestedBy"
							value={"customer"}
							onClick={() => setRequestedBy("Customer")}
						/>{" "}
						Customer{" "}
					</label>
					<label>
						{" "}
						<input
							readOnly
							type="radio"
							checked={requestedBy == "Org"}
							name="requestedBy"
							value={"org"}
							onClick={() => setRequestedBy("Org")}
						/>
						Org{" "}
					</label>
				</div>
				<div className="control">
					<label className="label">
						Description <span className={"optional"}> (Optional) </span>
					</label>
					<textarea
						className="textarea"
						placeholder="Why are you canceling this application? "
						value={reason}
						onChange={(e) => setReason(e.target.value)}
					/>
				</div>
			</div>
			<Admonition type={"is-danger"} message={<p>{warningMessage}</p>} title={"Warning"} />
		</AsyncResultModal>
	)
}
